<template>
  <div class="login" id="sso-login">
    <div class="limiter">
      <div class="container-login100">
        <div>
          <span class="login100-form-title p-b-26">单点登录中...</span>
        </div>
        <div class="wrap-login100">
          <div class="wrap-login100-form-btn login-loading" v-loading="loading"
            element-loading-background="rgb(0 0 0 / 0%);" element-loading-custom-class="login-loading-class"
            element-loading-text="正在验证身份...">
            <div style="height: 100px;"></div>
          </div>
          <div v-if="errorMsg" class="error-msg">
            {{ errorMsg }}
            <br />
            <el-button type="text" @click="goToLogin">返回普通登录</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import userService from "./service/UserService";

export default {
  name: 'SSOLogin',
  data() {
    return {
      loading: true,
      errorMsg: ''
    }
  },
  mounted() {
    this.handleSSO();
  },
  methods: {
    handleSSO() {
      const ticket = this.$route.query.ticket;
      const targetApp = this.$route.query.targetApp;

      if (!ticket) {
        this.loading = false;
        this.errorMsg = '未检测到SSO票据 (Ticket)';
        return;
      }

      this.$axios({
        method: 'POST',
        url: "/api/sso/login",
        params: {
          ticket: ticket,
          targetApp: targetApp
        }
      }).then((res) => {
        this.loading = false;
        debugger
        console.debug("SSO登录响应:", res.data);
        if (res.data.code === 0) {
          console.log("SSO登录成功");
          userService.setUser(res.data.data);
          // Token is automatically handled by axios interceptor in main.js
          this.$router.push('/');
        } else {
          this.errorMsg = res.data.msg || 'SSO登录失败';
        }
      }).catch((error) => {
        this.loading = false;
        console.error("SSO登录请求异常:", error);
        if (error.response && error.response.data && error.response.data.msg) {
          this.errorMsg = error.response.data.msg;
        } else {
          this.errorMsg = '登录请求异常';
        }
      });
    },
    goToLogin() {
      this.$router.push('/login');
    }
  }
}
</script>

<style scoped>
/* Reuse styles from Login.vue if possible, or add minimal styling */
.login {
  width: 100%;
  height: 100%;
  background-image: url('../../static/images/login-background.jpg');
  background-size: cover;
  background-position: center;
  display: flex;
  justify-content: center;
  align-items: center;
}

.limiter {
  width: 100%;
  margin: 0 auto;
}

.container-login100 {
  width: 100%;
  min-height: 100vh;
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  padding: 15px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}

.wrap-login100 {
  width: 390px;
  background: rgba(255, 255, 255, 0.3);
  border-radius: 10px;
  overflow: hidden;
  padding: 40px 55px 33px 55px;
  box-shadow: 0 5px 10px 0px rgba(0, 0, 0, 0.1);
  -moz-box-shadow: 0 5px 10px 0px rgba(0, 0, 0, 0.1);
  -webkit-box-shadow: 0 5px 10px 0px rgba(0, 0, 0, 0.1);
  -o-box-shadow: 0 5px 10px 0px rgba(0, 0, 0, 0.1);
  -ms-box-shadow: 0 5px 10px 0px rgba(0, 0, 0, 0.1);
}

.login100-form-title {
  display: block;
  font-family: Poppins-Bold;
  font-size: 30px;
  color: #fff;
  line-height: 1.2;
  text-align: center;
  text-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
}

.p-b-26 {
  padding-bottom: 26px;
}

.error-msg {
  text-align: center;
  color: #f56c6c;
  font-weight: bold;
  background: rgba(255, 255, 255, 0.8);
  padding: 10px;
  border-radius: 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/SSOLogin.vue